export const deleteFacetQuery = (baseUrl: string, facetId: string) => {
  const url = new URL(baseUrl);
  const params = new URLSearchParams(url.search);
  params.delete(facetId);
  url.search = params.toString();

  return url.toString();
};
